// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35wjR","footer":"styles_footer__1qXg4","passCodeTooltip":"styles_passCodeTooltip__1KTo8"};